import { render, staticRenderFns } from "./CategoryOffersComponent.vue?vue&type=template&id=5eb54d8a"
import script from "./CategoryOffersComponent.vue?vue&type=script&lang=js"
export * from "./CategoryOffersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports